export default __webpack_public_path__ + "static/media/rep_1.bc55a53b.mp3";